export default [
  {
    path: '/en/natinformation/servicelaget-koppar',
    redirect: '/en/natinformation/natforandringar'
  },
  {
    path: '/natinformation/servicelaget-koppar',
    redirect: '/natinformation/natforandringar'
  },
  {
    path: '/en/natinformation/kopparnatsfel',
    redirect: '/en/natinformation/natforandringar'
  },
  {
    path: '/natinformation/kopparnatsfel',
    redirect: '/natinformation/natforandringar'
  },
  {
    path: '/en/public/referenserbjudande',
    redirect: '/en/articles/referenserbjudande'
  },
  {
    path: '/public/referenserbjudande',
    redirect: '/articles/referenserbjudande'
  },
  {
    path: '/en/public/h-llbarhet',
    redirect: '/en/articles/hallbarhet'
  },
  {
    path: '/public/h-llbarhet',
    redirect: '/articles/hallbarhet'
  },
  {
    path: '/en/public/sakerhet',
    redirect: '/en/articles/sakerhet'
  },
  {
    path: '/public/sakerhet',
    redirect: '/articles/sakerhet'
  },
  {
    path: '/en/public/felanmalan/Information_om_fel_i_telenatet',
    redirect: '/en/articles/information-koppar-fel'
  },
  {
    path: '/public/felanmalan/Information_om_fel_i_telenatet',
    redirect: '/articles/information-koppar-fel'
  },
  {
    path: '/en/public/Natagare',
    redirect: '/en/articles/natagare'
  },
  {
    path: '/public/Natagare',
    redirect: '/articles/natagare'
  },
  {
    path: '/en/public/var-integritetspolicy',
    redirect: '/en/articles/integritetspolicy'
  },
  {
    path: '/public/var-integritetspolicy',
    redirect: '/articles/integritetspolicy'
  },
  {
    path: '/en/privat/om/integritetspolicy/cookiepolicy',
    redirect: '/en/articles/cookiepolicy'
  },
  {
    path: '/privat/om/integritetspolicy/cookiepolicy',
    redirect: '/articles/cookiepolicy'
  }
]
